import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoDichiarazioniFiscaliStep2Component } from './conservazione-carica-documento-dichiarazioni-fiscali-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-dichiarazioni-fiscali-step2', {
            url: '/conservazione-carica-dichiuarazoini-fiscali',
            ncyBreadcrumb: {
                label: 'Carica Dichiarazioni Fiscali',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-dichiarazioni-fiscali-step2 flex="100"></conservazione-carica-documento-dichiarazioni-fiscali-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoDichiarazioniFiscaliStep2Module: string = ng
    .module('conservazione-carica-documento-dichiarazioni-fiscali-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoDichiarazioniFiscaliStep2', ConservazioneCaricaDocumentoDichiarazioniFiscaliStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-dichiarazioni-fiscali-step2/conservazione-carica-documento-dichiarazioni-fiscali-step2.module.ts